import { render, staticRenderFns } from "./RecruitmentPublish.vue?vue&type=template&id=2380e70c"
import script from "./RecruitmentPublish.vue?vue&type=script&lang=js"
export * from "./RecruitmentPublish.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentPublish.vue?vue&type=style&index=0&id=2380e70c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports